/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { Map, Record } from 'immutable';

export interface SalesPayoutState extends Map<string, any> {

  payoutList: any;
  payoutListLoading: boolean;
  payoutListLoaded: boolean;
  payoutListFailed: boolean;
}

export const SalesPayoutStateRecord = Record({

    payoutList: [],
    payoutListLoading: false,
    payoutListLoaded: false,
    payoutListFailed: false,
});